import { AbstractModel } from './abstract-model';
import { autoserialize, inheritSerialization } from 'cerialize';

@inheritSerialization(AbstractModel)
export class RiderFeeDetail extends AbstractModel {
  @autoserialize
  transitProgramId: number;
  @autoserialize
  routeDistanceMiles: number;
  @autoserialize
  billablePassengerCount: number;
  @autoserialize
  extraMiles: number;
  @autoserialize
  mileageSurcharge: number;
  @autoserialize
  additionalPassengerSurcharge: number;
  @autoserialize
  riderFeeTotal: number;
  @autoserialize
  baseRiderFee: number;
  @autoserialize
  riderFeeBaseDistance: number;
  @autoserialize
  riderFeeDistanceRate: number;
  @autoserialize
  additionalPassengerFee: number;
}
